export var sorts = [{
  orderBy: '-created_at',
  label: 'Most Recent',
  sort: false,
  value: 'most-recent'
}, {
  orderBy: '-upvotes,-created_at',
  label: 'Most Helpful',
  sort: true,
  value: 'most-helpful'
}];